export enum AdjustTypeEnum {
  /** 提额（提升的额度会直接放在固定额度中） */
  INCREASE = 'increaseQuota',
  /** 临时额度（不会直接加在固定额度中） */
  TEMP = 'temp',
}
export interface AdjustQuotaType {
  /** 调额类型 */
  adjustType: AdjustTypeEnum,
  /** 调整额度值 */
  adjustValue: number,
  /** 额度失效时间，adjustType为temp才会返回 */
  tempCreditExpiryTime: string,
}
